export default "__VITE_ASSET__Ch7Kk0oT__"